/**
 * @file api配置
 * @author fuqiang15(fuqiang15@baidu.com)
 *
 * api 配置可以搞个公共的，毕竟有很多接口是复用
 */

export default {
    constants: '/data/system/constants',
    session: '/data/system/session',
    // 账户中心
    userSmscodeSend: '/data/user/smscode/send',
    userUpdate: '/data/user/update',
    userStateEdit: '/data/user/state/edit',
    userQualificationList: '/data/user/qualification/list',
    userQualificationDetail: '/data/user/qualification/detail',
    passwordUpdate: '/data/user/password/update',
    userQualificationApply: '/data/user/qualification/apply',
    userQualificationSave: '/data/user/qualification/save',

    // 应用
    appList: '/data/app/list',
    appCreate: '/data/app/create',
    appUpdate: '/data/app/update',
    appDetail: '/data/app/detail',
    appDelete: '/data/app/delete',

    aderList: '/data/ader/list',
    suggestionAderList: '/data/suggestion/ader/list',

    // 服务
    appServiceList: '/data/app/service/list',
    appServiceDetail: '/data/app/service/detail',
    appServicePublish: '/data/app/service/publish',
    appServiceDelete: '/data/app/service/delete',
    appServiceCopy: '/data/app/service/copy',

    // 应用服务 - AR
    appServiceARDetail: '/data/app/service/ar/detail',
    appServiceARCaseEdit: '/data/app/service/ar/case/edit',
    appServiceARTemplateDetail: '/data/app/service/ar/template/detail',
    appServiceARMaterialSubmit: '/data/app/service/ar/material/submit',
    appServiceARMediaUpload: '/data/app/service/ar/media/upload',
    appServiceARTemplateList: '/data/app/service/ar/template/list',
    appServiceARUpdate: '/data/app/service/ar/update',
    appServiceARCreate: '/data/app/service/ar/create',
    appServiceARPublish: '/data/app/service/ar/publish',

    // 应用服务 - audio
    appServiceAudioDemo: '/data/app/service/audio/demo',
    appServiceAudioDraftUpdate: '/data/app/service/audio/draft/update',
    appServiceAudioCreate: '/data/app/service/audio/create',

    // 应用服务 - vote
    appServiceVoteUpdate: '/data/app/service/vote/update',
    appServiceVoteDraftUpdate: '/data/app/service/vote/draft/update',
    appServiceVoteCreate: '/data/app/service/vote/create',

    // 应用服务 - schema
    appServiceSchemaDraftUpdate: '/data/app/service/schema/draft/update',
    appServiceSchemaUpdate: '/data/app/service/schema/update',
    appServiceSchemaCreate: '/data/app/service/schema/create',
    appServiceFormReportList: '/data/app/service/schema/report/list',

    // 应用服务 - lottery
    appServiceLotteryDownload: '/data/app/service/lottery/download',
    appServiceLotteryUpload: '/data/app/service/lottery/upload',
    appServiceLotteryPublish: '/data/app/service/lottery/publish',
    appServiceLotteryDetail: '/data/app/service/lottery/detail',
    appServiceLotteryDraftUpdate: '/data/app/service/lottery/draft/update',
    appServiceLotteryUpdate: '/data/app/service/lottery/update',
    appServiceLotteryCreate: '/data/app/service/lottery/create',

    // 应用服务 - custom
    appServiceCustomReview: '/data/app/service/custom/review',
    appServiceCustomAPITestDetail: '/data/app/service/custom/api/test/detail',
    appServiceCustomAPITest: '/data/app/service/custom/api/test',
    appServiceCustomAPIList: '/data/app/service/custom/api/list',
    appServiceCustomUpdate: '/data/app/service/custom/update',
    appServiceCustomCreate: '/data/app/service/custom/create',
    appServiceCustomAPICreate: '/data/app/service/custom/api/create',
    appServiceCustomAPIUpdate: '/data/app/service/custom/api/update',
    appServiceCustomAPIDetail: '/data/app/service/custom/api/detail',
    appServiceCustomAPIDelete: '/data/app/service/custom/api/delete',

    // 应用服务 - weibo
    appServiceWeiboUpdate: '/data/app/service/weibo/update',
    appServiceWeiboCreate: '/data/app/service/weibo/create',

    // 应用服务 - map
    appServiceMapCreate: '/data/app/service/map/create',
    appServiceMapUpdate: '/data/app/service/map/update',
    appServiceMapStoreList: '/data/app/service/map/store/list',
    appServiceMapStoreTableInfo: '/data/app/service/map/store/table/detail',
    appServiceMapStoreDelete: '/data/app/service/map/store/delete',
    appServiceMapStoreBatchDelete: '/data/app/service/map/store/batchdelete',
    appServiceMapStoreFieldCreate: '/data/app/service/map/store/field/create',
    appServiceMapStoreFieldUpdate: '/data/app/service/map/store/field/update',
    appServiceMapStoreFieldDelete: '/data/app/service/map/store/field/delete',
    appServiceMapStoreSync: '/data/app/service/map/store/sync',
    appServiceCustomOffline: '/data/app/service/custom/offline',
    resourcePrivateUpload: '/data/resource/private/upload',
    resourcePublicUpload: '/data/resource/public/upload',
    appLogoUpload: '/data/app/logo/upload',
    agreementConfirm: '/data/agreement/confirm',
    agreementDownload: '/data/agreement/download',

    // 应用服务 - map2
    appServiceMap2Create: '/data/app/service/map2/create',
    appServiceMap2Update: '/data/app/service/map2/update',
    appServiceMap2StoreList: '/data/app/service/map2/store/list',
    appServiceMap2StoreTableInfo: '/data/app/service/map2/store/table/detail',
    appServiceMap2StoreDelete: '/data/app/service/map2/store/delete',
    appServiceMap2StoreBatchDelete: '/data/app/service/map2/store/batchdelete'
};
